import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, Input, Button, Form, Select, message } from "antd";
import storageUtils from "../../utils/storageUtils";
import { getDateYYYYMMDD } from "../../utils/dateUtil";
import { req_add_pim_define_day } from "../../api";

const Item = Form.Item;
class StandardTimeStaffAddModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    data: PropTypes.object.isRequired,
  };

  state = {
    workStatusList: [
      { label: "停班", value: "PASS" },
      { label: "上班", value: "WORK" },
    ],
    reasonList: [
      { label: "停班停課", value: "停班停課" },
      { label: "補休日", value: "補休日" },
      { label: "國定假日", value: "國定假日" },
      { label: "休息日", value: "休息日" },
      { label: "例假日", value: "例假日" },
      { label: "工作日", value: "工作日" },
      { label: "補班日", value: "補班日" },
    ],
    selectedWorkStatus: "PASS",
    inputDate: getDateYYYYMMDD(new Date()),
    selectedReason: "休息日",
    inputBunchIn: "0800",
    inputBunchOut: "1700",
    inputRecordDescription: "",
    item: {
      DefineDate: getDateYYYYMMDD(new Date()),
      DefineBunchIn: "0800",
      DefineBunchOut: "1700",
      DefineReason: "休息日",
      DefineStatus: "PASS",
      RecordDescription: "",
      RecordCreatorCode: this.props.user.userCode,
    },
  };


  api_modify_item = async (item) => {
      const result = await req_add_pim_define_day(
        item,
        storageUtils.getUser().token
      );
      if (result.status === "success") {
        message.success(result.message);
      } else {
        message.error(result.message);
      }
  
  };


  // 操作互動處理 //////////////////////////////////////////////
  handleWorkStatusChange = (value) => {
    //console.log(value);
    this.setState({ selectedWorkStatus: value });
  };

  handleReasonChange = (value) => {
    //console.log(value);
    this.setState({ selectedReason: value });
  };

  onFinish = (values) => {
    const { item, selectedWorkStatus, selectedReason, } = this.state;
    console.log("Success:", values);
    item.DefineDate = values.inputDate;
    item.DefineBunchIn = values.inputBunchIn;
    item.DefineBunchOut = values.inputBunchOut;
    item.DefineReason = selectedReason;
    item.DefineStatus = selectedWorkStatus;
    item.RecordDescription = values.inputRecordDescription;
    //console.log(item);
    this.api_modify_item(item);
  };

  render() {
    const {
      inputDate,
      inputBunchIn,
      inputBunchOut,
      inputRecordDescription,
      selectedReason,
      reasonList,
      selectedWorkStatus,
      workStatusList,
    } = this.state;

    return (
      <Card>
        <Form onFinish={this.onFinish}>
          <Item
            label="日期分類"
            rules={[
              { required: true, whitespace: true, message: "必須填寫內容" },
            ]}
          >
            <Select
              defaultValue={selectedReason}
              onChange={this.handleReasonChange}
              style={{
                width: "100%",
              }}
              options={reasonList}
            />
          </Item>
          <Item
            label="作息狀態"
            rules={[
              { required: true, whitespace: true, message: "必須填寫內容" },
            ]}
          >
            <Select
              defaultValue={selectedWorkStatus}
              onChange={this.handleWorkStatusChange}
              style={{
                width: "100%",
              }}
              options={workStatusList}
            />
          </Item>
          <Item
            label="作息日期"
            name="inputDate"
            initialValue={inputDate}
            rules={[
              { required: true, whitespace: true, message: "必須填寫內容" },
            ]}
          >
            <Input placeholder="日期格式: 20240101" />
          </Item>
          <Item
            label="作息起始時間"
            name="inputBunchIn"
            initialValue={inputBunchIn}
            rules={[
              { required: true, whitespace: true, message: "必須填寫內容" },
            ]}
          >
            <Input placeholder="時間格式: 0800" />
          </Item>
          <Item
            label="作息結束時間"
            name="inputBunchOut"
            initialValue={inputBunchOut}
            rules={[
              { required: true, whitespace: true, message: "必須填寫內容" },
            ]}
          >
            <Input placeholder="時間格式: 1700" />
          </Item>
          <Item
            label="作息說明"
            name="inputRecordDescription"
            initialValue={inputRecordDescription}
          >
            <Input placeholder="" />
          </Item>
          <Item>
            <Button type="primary" htmlType="submit" className="wave" block>
              {"送出"}
            </Button>
          </Item>
        </Form>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(StandardTimeStaffAddModal);
